// ============================================================================
// LINK-CUT TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'link-cut-tree',
  name: 'Link-Cut Tree',
  category: 'Graphs',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A data structure for maintaining a forest of rooted trees under dynamic operations like link, cut, and path queries. It uses splay trees to represent preferred paths and supports efficient tree operations.'
};
